import * as React from "react"
import {DrawerSeeker} from "@ui-seeker/core";
import {isEmpty} from "@ui-seeker/utils";

import {productPagesModalData} from "../@signals";
import {useProductPagesMultimediaData} from "../@hooks";
import {Box, CircularProgress} from "@mui/material";
import ProductPagesDetailsModalContent from "./Content";


export default function ProductPagesDetailsModal() {
    const { isLoading, data } = useProductPagesMultimediaData()

    return <DrawerSeeker
        isOpen={!isEmpty(productPagesModalData.value)}
        controller={() => productPagesModalData.value = {}}
        title="Product Page Details"
        width="35%"
    >
        { !!isLoading && <Box sx={{ height: .6, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <CircularProgress size={120} />
        </Box> }
        { !isLoading && !isEmpty(data) && <ProductPagesDetailsModalContent data={data} /> }
    </DrawerSeeker>
}